module.exports = __webpack_public_path__ + "img/II-12.61f2e09a.svg";